import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  svg: {},
  path: {
    fill: '#7df3e1',
  },
  group: {
    display: 'grid',
    gridTemplateColumns: '30px 1fr',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.common.white,
    fontSize: '1.25rem',
    flex: '1',
  },
}));
const LogoFull = () => {
  const styles = useStyles();
  return (
    <div className={styles.group}>
      <svg
        className={styles.svg}
        aria-label="Ironclad Logo"
        fill="none"
        height="18"
        viewBox="0 0 17 18"
        width="17"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 0.0947368V1.8C0 1.85211 0.0425638 1.89474 0.0945862 1.89474H7.09397V16.1053H0.0945862C0.0425638 16.1053 0 16.1479 0 16.2V17.9053C0 17.9574 0.0425638 18 0.0945862 18H15.9851C16.0371 18 16.0797 17.9574 16.0797 17.9053V16.2C16.0797 16.1479 16.0371 16.1053 15.9851 16.1053H8.98569V1.89474H15.9851C16.0371 1.89474 16.0797 1.85211 16.0797 1.8V0.0947368C16.0797 0.0426316 16.0371 0 15.9851 0H0.0945862C0.0425638 0 0 0.0426316 0 0.0947368Z"
          fill="#00CA88"
        />
        <path
          d="M11.2085 4.02632C11.1564 4.02632 11.1139 4.06895 11.1139 4.12106V13.879C11.1139 13.9311 11.1564 13.9737 11.2085 13.9737H12.911L12.9118 13.9737H15.9851C16.0371 13.9737 16.0796 13.9311 16.0796 13.8789V12.1737C16.0796 12.1216 16.0371 12.0789 15.9851 12.0789H13.0056V5.92106H15.9851C16.0371 5.92106 16.0796 5.87842 16.0796 5.82632V4.12106C16.0796 4.06895 16.0371 4.02632 15.9851 4.02632H11.2085Z"
          fill="#00CA88"
        />
        <path
          d="M4.87118 4.02632C4.92321 4.02632 4.96577 4.06895 4.96577 4.12106V13.879C4.96577 13.9311 4.92321 13.9737 4.87118 13.9737H3.16863L3.16781 13.9737H0.0945862C0.0425638 13.9737 0 13.9311 0 13.8789V12.1737C0 12.1216 0.0425638 12.0789 0.0945862 12.0789H3.07405V5.92106H0.0945862C0.0425638 5.92106 0 5.87842 0 5.82632V4.12106C0 4.06895 0.0425638 4.02632 0.0945862 4.02632H4.87118Z"
          fill="#00CA88"
        />
      </svg>
      <span className={styles.link}>Ironclad</span>
    </div>
  );
};

export default LogoFull;
